import React from 'react';
import {
  UserIcon,
  HomeIcon,
  BellNotificationIcon,
  SecurityKeyIcon,
} from '@rsos/assets/icons';
import {
  AGENCY_INFO_CONTENT,
  USERS_CONTENT,
  NOTIFICATIONS_CONTENT,
  SSO_CONTENT,
} from '@rsos/constants/adminContents';
import type { SideBarMenuItem } from '../common/types';

// Presentation only. Each item's permission, capability and flag requirements
// live in adminRouteAccess (@rsos/capstone/src/constants/adminRouteAccess), keyed by `link`,
// so the nav and the route guards cannot disagree.
const cspSideBarItems: SideBarMenuItem[] = [
  {
    id: 'configCSPInfo',
    link: '/admin/psap',
    menuTitle: 'Account Info',
    menuIcon: <HomeIcon width={12} height={12} />,
    name: AGENCY_INFO_CONTENT,
  },
  {
    id: 'configUsers',
    link: '/admin/access/users',
    menuTitle: 'Users',
    menuIcon: <UserIcon width={12} height={12} />,
    name: USERS_CONTENT,
  },
  {
    id: 'configNotifications',
    link: '/admin/notifications',
    menuTitle: 'Notifications',
    menuIcon: <BellNotificationIcon width={12} height={12} />,
    name: NOTIFICATIONS_CONTENT,
  },
  {
    id: 'configSSO',
    link: '/admin/access/sso',
    menuTitle: 'Manage SSO',
    menuIcon: <SecurityKeyIcon width={12} height={12} />,
    name: SSO_CONTENT,
  },
];

export default cspSideBarItems;
